import { Component, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { BaseStepComponent } from '../../../base';
import { Validators, FormGroup } from '@angular/forms';
import { Element } from '@angular/compiler';


@Component({
    selector: 'gerenciar-permissoes-etapa1',
    templateUrl: './gerenciar-permissoes-etapa1.component.html',
})
export class CrudGerenciarPermissoesEtapa1Component extends BaseStepComponent {
    @Input() SistemaOptions: SelectItem[];
    @Input() PerfilOptions: SelectItem[];
    @Input() LotacaoOptions: SelectItem[];
    @Input() UsuarioOptions: SelectItem[];
    @Input() StatusOptions: SelectItem[];


    pesquisaUsuario() {
        this.cadastro.get("usuario").setValue("");
        if (this.cadastro.value.cpf != "") {
            let cpf = this.cadastro.value.cpf.replace('.', '').replace('.', '').replace('.', '').replace('-', '');
            this.service.ObterTodos("usuario/listarTodos", { query: cpf }).subscribe(obj => {
                if (obj.length > 0) {
                    this.cadastro.get("usuario").setValue(obj[0].nome);
                    this.cadastro.get("id_usuario").setValue(obj[0].id);
                } else {
                    this.msgs = [];
                    this.msgs.push({ severity: 'warn', summary: 'Mensagem de Erro', detail: 'CPF não localizado' });
                }
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/gerenciar-permissoes/crud/etapas/gerenciar-permissoes-etapa1.component.ts